import { useState, useEffect } from 'react';
import Navbar from '../components/navBar';

function Awards() {
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAwards = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/awards`);
        if (!response.ok) {
          throw new Error('Failed to fetch awards');
        }
        const data = await response.json();
        setAwards(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchAwards();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="min-h-screen bg-gray-800">
      <Navbar />
      <div className="container mx-auto px-4 py-8 pt-20">
        <h1 className="text-3xl font-bold mb-6 text-white">Awards</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {awards.map((award) => (
            <div key={award.awardId} className="bg-gray-900 p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-700">
              <img 
                src={award.imageUrl} 
                alt={award.name}
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <div className="space-y-2">
                <h2 className="text-xl font-semibold text-white">{award.name}</h2>
                <p className="text-gray-300">{award.description}</p>
                <div className="flex items-center space-x-2">
                  <span className="px-3 py-1 bg-blue-900 text-blue-100 rounded-full text-sm">
                    {award.category}
                  </span>
                </div>
                <p className="text-sm text-gray-400">
                  Date: {new Date(award.createdAt).toLocaleDateString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Awards;
